var componentRequireContext = require.context("components", true, /front\/search_page\/*/);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

